import type { HTMLAttributes } from 'react'
import { cn } from '../lib/cn.ts'

// Dark panel: hairline border on the raised surface, square corners, no drop
// shadow. Depth in this system comes from borders and ground steps, not blur.
export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('rounded-none border border-border-hairline-strong bg-ground-surface', className)} {...rest} />
  )
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-4 py-4', className)} {...rest} />
}
